import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectCoopInfo } from "../../../selectors/selectCoopInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopProjectStartSuccess, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopProjectStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.StartCoopProject), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var coopId = selectCoopInfo(state).id;
        return deps
            .netSend({
            id: CommandCode.StartCoopProject,
            props: {
                coopId: coopId,
                difficulty: action.difficulty,
                playerId: playerId,
                typeId: action.coopProjectId,
            },
        })
            .pipe(switchMap(function (response) {
            var actions = [actionCoopProjectStartSuccess(response)];
            return from(actions);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopProjectStart.ts
// module id = 1820
// module chunks = 3